module.exports = __webpack_public_path__ + "static/media/safety-reman-4.9a63174a.png";